import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function reportVisitEventConfiguration({ rootId }) {
  return new NetworkRequestConfiguration({
    endpoint: 'attributions/touch_attributions/report_visit_event',
    method: NetworkRequestConfiguration.Methods.POST,
    bodyParameters: {
      rootId,
    },
  });
}

